export default __webpack_public_path__ + "static/bioage-en-08c8836acaf3140ec2498e6412a57d4a.png";